export default function LandingPage(){
    return(
    <div className="landing-page">
        <div className="company">
            <h1 className="company-name">GOOD-WILL<br/>Cargo</h1>
            <h3 className="tag-line">You Book It,<br/>We'll Ship It.</h3>
        </div>
        <div className="landing-page-overlay"></div>
        <div className="landing-page-img"></div>
    </div>
    );
}